export default __webpack_public_path__ + "static/media/LPDM_short.e0095de0.webm";